<template>
    <q-select v-model="localeKey"
              :options="localesMapped"
              @input="setLocale(localeKey)">
    </q-select>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {loadMessages} from '../../plugins/i18n'
    import {
        QSelect
    } from 'quasar-framework'

    export default {

        computed: {
            ...mapGetters({
                locale: 'lang/locale',
                locales: 'lang/locales',
            }),
            currentFlag() {
                return this.flagFor(this.locale)
            },
            localesMapped() {
                return [{value: 'es', label: 'Castellano'}, {value: 'en', label: 'English'}]
            }
        },

        data() {
            return {
                localeKey: ''
            }
        },

        components: {
            QSelect,
        },
        methods: {
            setLocale(locale) {
                if (this.$i18n.locale !== locale) {
                    loadMessages(locale)

                    this.$store.dispatch('lang/setLocale', {locale})
                }
            },
            flagFor(locale) {
                return `${config.appUrl}${config.devAssetsFolder}/img/locale/${locale}.svg`
            }
        },

        mounted() {
            this.localeKey = this.locale
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/_overrides/LocaleDropdown.vue